import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import useFetchURL from '../../../../../../../elements/Hooks/useFetchURL'
import { get } from 'lodash'
import React, { Fragment } from 'react'
import AccountsCascader from '../../../../../../../elements/Cascader/AccountsCascader'
import TaxType from '../../../../../../../elements/Select/Lines/TaxType'
import UOM from '../../../../../../../elements/Select/UOM'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../../../../modules/FormItems'
import { dateVal, findCascadersParents, strVal } from '../../../../../../../modules/Utils'

const { TextArea } = Input

function BillLineForm(props) {
  const handleChange = (value, _id) => {
    if (_id === 'tax.type') {
      value === 'zer' && props.form.setFieldsValue({ 'tax.rate': 0 })
    }
  }

  const { data: accounts } = useFetchURL(`foxxapi/accounts?select=_id,name,_parent`)

  const { getFieldDecorator } = props.form
  const { billLine, billLineModalType, isUpdatable, invoice } = props
  const isConfirmed = ['Confirmed'].includes(invoice.status)

  console.log(findCascadersParents(accounts, strVal(billLine, 'account._id')))
  console.log(get(invoice, 'center._id'), get(invoice, 'company._id'))
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Client Requisition No.'}>
            {getFieldDecorator('reqNo', {
              initialValue: get(billLine, 'reqNo'),
            })(<Input disabled={isConfirmed} placeholder={'Client Requisition No.'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Percentage Billed'}>
            {getFieldDecorator('percentageBill', {
              initialValue: get(billLine, 'percentageBill') || 100,
              rules: [
                {
                  required: true,
                  message: "Percentage Billed can't be Empty!",
                },
              ],
            })(
              <Input
                disabled={!isUpdatable || isConfirmed}
                style={{ width: '100%' }}
                placeholder={'Percentage'}
                addonAfter={'%'}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Client account No.'}>
            {getFieldDecorator('accountNo', {
              initialValue: get(billLine, 'accountNo'),
            })(<Input disabled={isConfirmed} placeholder={'Client account No.'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Don't Include in Reports">
            {getFieldDecorator('isNonPayAndLoss', {
              initialValue: get(billLine, 'isNonPayAndLoss'),
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'No'}>
            {getFieldDecorator('no', {
              initialValue: get(billLine, 'no'),
              rules: [{ required: true, message: "No can't be Empty!" }],
            })(<Input disabled={isConfirmed} placeholder={'No'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Name'}>
            {getFieldDecorator('name', {
              initialValue: get(billLine, 'name'),
              rules: [
                {
                  required: true,
                  message: "Name can't be Empty!",
                },
              ],
            })(<Input disabled={isConfirmed} placeholder={'Name'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
            {getFieldDecorator('description', {
              initialValue: get(billLine, 'description'),
              rules: [{ required: true, message: "Description can't be Empty!" }],
            })(<TextArea disabled={isConfirmed} placeholder={'Description'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {billLineModalType !== 'edit' && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Percent'}>
              {getFieldDecorator('ipercent', {
                initialValue: get(billLine, 'ipercent'),
                rules: [{ required: true, message: "Percent can't be Empty!" }],
              })(
                <InputNumber disabled={!isUpdatable || isConfirmed} style={{ width: '100%' }} placeholder={'Percent'} />
              )}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Rate (U/Price) '}>
            {getFieldDecorator('rate', {
              initialValue: get(billLine, 'rate'),
              rules: [{ required: true, message: 'Please Select a Rate!' }],
            })(<InputNumber disabled={isConfirmed} style={{ width: '100%' }} placeholder={'Rate'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="UoM">
            {getFieldDecorator('uom.code', {
              initialValue: get(billLine, 'uom.code'),
              rules: rules.select,
            })(<UOM disabled={isConfirmed} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Unit'}>
            {getFieldDecorator('unit', {
              initialValue: get(billLine, 'unit'),
              rules: [{ required: true, message: 'Please Select a Unit!' }],
            })(<InputNumber disabled={isConfirmed} placeholder={'Unit'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
            {getFieldDecorator('tax.type', {
              initialValue: get(billLine, 'tax.type'),
              rules: [{ required: true, message: 'Please Select a Tax Type!' }],
            })(
              <TaxType
                style={{ width: '100%' }}
                placeholder={'Tax Rate'}
                disabled={isConfirmed}
                onChange={(v) => handleChange(v, 'tax.type')}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Tax Rate'}>
            {getFieldDecorator('tax.rate', {
              initialValue: get(billLine, 'tax.rate'),
              rules: [{ required: true, message: 'Please Select a Tax Rate!' }],
            })(<InputNumber style={{ width: '100%' }} disabled={isConfirmed} placeholder={'Tax Rate'} />)}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Account'}>
            {getFieldDecorator('account._id', {
              initialValue: findCascadersParents(accounts, strVal(billLine, 'account._id')),
              rules: rules.select,
            })(
              <AccountsCascader
                company={get(invoice, 'company._id')}
                placeholder={'Account'}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      {get(billLine, 'orderLine.type') === 'booking' && (
        <Fragment>
          {get(billLine, 'product.category.code') === 'VR' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Booking Details</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('orderLine.booking.pickup.date', {
                      rules: [{ required: true, message: 'Please Select a Start!' }],
                      initialValue: dateVal(billLine.orderLine, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        placeholder="Start Date"
                        disabled={isConfirmed}
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('orderLine.booking.dropoff.date', {
                      initialValue: dateVal(billLine.orderLine, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        placeholder="End Date"
                        disabled={isConfirmed}
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <h3>Vehicle</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('orderLine.booking.vehicle.name', {
                      initialValue: get(billLine.orderLine, 'booking.vehicle.name'),
                    })(<Input disabled={isConfirmed} placeholder={'Vehicles'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('orderLine.booking.vehicle.plate', {
                      initialValue: get(billLine.orderLine, 'booking.vehicle.plate'),
                    })(<Input disabled={isConfirmed} placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}

          {get(billLine, 'product.category.code') === 'VD' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Booking Details</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('orderLine.booking.pickup.date', {
                      rules: [{ required: true, message: 'Please Select a Start!' }],
                      initialValue: dateVal(billLine.orderLine, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabled={isConfirmed}
                        placeholder="Start Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('orderLine.booking.dropoff.date', {
                      initialValue: dateVal(billLine.orderLine, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        placeholder="End Date"
                        disabled={isConfirmed}
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <h3>Vehicle</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('orderLine.booking.vehicle.name', {
                      initialValue: get(billLine.orderLine, 'booking.vehicle.name'),
                    })(<Input disabled={isConfirmed} placeholder={'Vehicles'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('orderLine.booking.vehicle.plate', {
                      initialValue: get(billLine.orderLine, 'booking.vehicle.plate'),
                    })(<Input disabled={isConfirmed} placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Driver Name'}>
                    {getFieldDecorator('orderLine.booking.vehicle.driver', {
                      initialValue: get(billLine.orderLine, 'booking.vehicle.driver'),
                    })(<Input disabled={isConfirmed} placeholder={'Driver Name'} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}
          {get(billLine, 'product.category.code') === 'chauffeur-services' && (
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'PickUp Notes'}>
                  {getFieldDecorator('orderLine.booking.pickup.notes', {
                    initialValue: get(billLine, 'orderLine.booking.pickup.notes'),
                  })(<Input disabled={isConfirmed} placeholder="Notes" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'PickUp Address'}>
                  {getFieldDecorator('orderLine.booking.pickup.label', {
                    initialValue: get(billLine, 'orderLine.booking.pickup.label'),
                  })(<Input disabled={isConfirmed} placeholder={'Display Address'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'DropOff Notes'}>
                  {getFieldDecorator('orderLine.booking.dropoff.notes', {
                    initialValue: get(billLine, 'orderLine.booking.dropoff.notes'),
                  })(<Input disabled={isConfirmed} placeholder="Notes" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'DropOff Address'}>
                  {getFieldDecorator('orderLine.booking.dropoff.label', {
                    initialValue: get(billLine, 'orderLine.booking.dropoff.label'),
                  })(<Input disabled={isConfirmed} placeholder={'DropOff Address'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
        </Fragment>
      )}
    </Form>
  )
}

BillLineForm.propTypes = {}
BillLineForm.defaultProps = {
  billLine: {},
  type: 'new',
}

export default Form.create()(BillLineForm)
